import React, {useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { Checkbox } from "@mui/material";
import { pink } from "@mui/material/colors";
import { useMutation } from "react-query";
import apiService from "../../../api/apiService";
import Loading from "../Loading";
import moment from 'moment';
import { presentationDownloader } from "../../../utils/blobDownloader";

const Form = styled.form`
  max-width: 465px;
  .alert {
    color: red;
    font-weight: bold;
  }
`;

const InputContainer = styled.div`
  margin: 15px 0;
`;

const Description = styled.div`
  font-size: 14px;
  color: var(--color-form-font-description);
  margin-bottom: 5px;
`;

const Label = styled.label`
  color: var(--color-form-font-description); ;
`;

const SubmitInput = styled.input`
  margin-top: 10px;
  color: white;
  border: none;
  width: 150px;
  height: 36px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background-color: var(--color-brand-pink-primary);

  &:hover {
    box-shadow: 0px 0px 15px -5px rgba(236, 64, 122, 100);
  }
`;

const PlatformTab = () => {
  const [isDataFilled, setIsDataFilled] = useState("");
  const [attackVectors, setAttackVectors] = useState("Mobile,Cloud,Email");
  const { handleSubmit, register } = useForm();

  const { mutate: downloadPresentation, isLoading } = useMutation(
    (formData) =>
        apiService.downloadIntelligenceReportByPlatform(formData),
    {
      onSuccess: async (res) => {
        let dateTime = new Date();
        dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
        const vectors = attackVectors.length > 1 ? attackVectors.replace(new RegExp(",", "g"), '_').slice(0) : attackVectors;
        const fileName = vectors + "_" + dateTime;
        await presentationDownloader(res, fileName);

        apiService.contentCreated({
          attack_vectors: attackVectors,
          type: "platforms",
        }, "Intelligence").catch(console.error);
      },
    }
  );

  const onPlatformSubmit = (data) => {
    setIsDataFilled(true);
    setAttackVectors(Object.values(data).filter(Boolean).join(","));
  };

  useEffect(()=>{
    if (attackVectors === "") {
      setIsDataFilled(false);
    } else if(isDataFilled){
      const platformFormData = {
        attack_vectors: attackVectors,
        type: "platforms",
      };
      downloadPresentation(platformFormData);
    }
  },[attackVectors, isDataFilled, downloadPresentation])

  const checkBoxStyle = {
    color: pink[600],
    "& .MuiSvgIcon-root": { fontSize: 24 },
    "&.Mui-checked": { color: pink[600] },
  };

  if (isLoading === true) {
    return <Loading />;
  }

  return (
    <div>
      <Form onSubmit={handleSubmit((data) => onPlatformSubmit(data))}>
        <Description>Please select the requested Platform(s)</Description>
        <InputContainer>
          <Label>
            <Checkbox
              type="checkbox"
              name="mobile"
              value="Mobile"
              defaultChecked
              {...register("mobile")}
              onChange={() => setIsDataFilled("")}
              sx={{
                ...checkBoxStyle,
              }}
            />
            Mobile
          </Label>
          <Label>
            <Checkbox
              type="checkbox"
              name="cloud"
              value="Cloud"
              defaultChecked
              {...register("cloud")}
              onChange={() => setIsDataFilled("")}
              sx={{
                ...checkBoxStyle,
              }}
            />
            Cloud
          </Label>
          <Label>
            <Checkbox
              type="checkbox"
              name="email"
              value="Email"
              defaultChecked
              {...register("email")}
              onChange={() => setIsDataFilled("")}
              sx={{
                ...checkBoxStyle,
              }}
            />
            Email
          </Label>
        </InputContainer>
        <SubmitInput
          id="GeneratePlatformReport"
          type="submit"
          value="Generate Report"
        />
        {isDataFilled === false && (
            <p className="alert">Please choose at least one Platform.</p>
        )}
      </Form>
    </div>
  );
};

export default PlatformTab;
